<app-header [isAnpp]="isAnpp"></app-header>
<div class="main-container" [ngClass]="{'anpp': isAnpp}">
    <app-menu [isAnpp]="isAnpp"></app-menu>
    @if (displayPage) {
      <div id="page-content">
        <router-outlet></router-outlet>
      </div>
    }
</div>
